// extracted by mini-css-extract-plugin
export var plainBtn = "components-banners-__ComingSoon-module___plainBtn";